import type { PropsWithChildren } from "react";
import type { Control, FieldErrors, FieldValues } from "react-hook-form";

import FormSection from "~/components/formElements/FormSection";
import Select from "~/components/formElements/Select";
import type { FormInputOption } from "~/types/form.ts";

type ProgramAndQuotaForm<T extends FieldValues> = {
	control: Control<T>;
	errors: FieldErrors<T>;
	programSelectOptions: FormInputOption[];
	quotaSelectOptions: FormInputOption[];
	programInputDisabled: boolean;
	quotaInputDisabled: boolean;
};

type ProgramAndQuotaFormSectionType = {
	programId: string | null;
	quotaId: string | null;
};

const ProgramAndQuotaFormSection = <T extends ProgramAndQuotaFormSectionType>({
	control,
	errors,
	programSelectOptions,
	quotaSelectOptions,
	programInputDisabled,
	quotaInputDisabled,
}: PropsWithChildren<ProgramAndQuotaForm<T>>) => {
	return (
		<FormSection title="Zuordnung">
			<div className="grid grid-cols-6 gap-x-6 gap-y-2">
				<div className="col-span-6">
					<Select
						name="programId"
						disabled={programInputDisabled}
						label="Programm"
						optionsData={programSelectOptions}
						control={control}
						error={errors.programId?.message as string}
					/>
				</div>
				<div className="col-span-6">
					<Select
						name="quotaId"
						disabled={quotaInputDisabled}
						label="Abrechnungskontingent"
						optionsData={quotaSelectOptions}
						control={control}
						error={errors.quotaId?.message as string}
					/>
				</div>
			</div>
		</FormSection>
	);
};

export default ProgramAndQuotaFormSection;
